import { PmiButton } from 'shell/components/shared/button';
import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { FormikProps } from 'formik';
import { useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import MunicipalityAutoComplete from 'system/components/shared/search-municipality';
import { FiltersFormConsulate } from 'system/geographic/pages/consulate/list/types';
import PmiTextField from 'shell/components/shared/text-field';

interface FiltersConsulateProps {
  filterConsulateForm: FormikProps<FiltersFormConsulate>;
  // onChangeMunicipality?: (value: string) => void;
}

const FiltersConsulate = ({
  filterConsulateForm,
}: // onChangeMunicipality,
FiltersConsulateProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-consulate-content"
        id="panel-consulate-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterConsulateForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Codice consolato"
                label="Codice"
                id="code"
                name="code"
                fullWidth
                onBlur={filterConsulateForm.handleBlur}
                type="text"
                variant="outlined"
                inputProps={{
                  maxLength: '7',
                  pattern: '[0-9]*',
                }}
                value={filterConsulateForm.values.code}
                onChange={(event) =>
                  filterConsulateForm.setFieldValue(
                    'code',
                    event.target.validity.valid
                      ? event.target.value
                      : filterConsulateForm.values.code
                  )
                }
                error={filterConsulateForm.touched.code && Boolean(filterConsulateForm.errors.code)}
                helperText={filterConsulateForm.errors.code}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <MunicipalityAutoComplete
                selectedValue={filterConsulateForm.values.municipality || { description: '' }}
                handleChange={(value) => filterConsulateForm.setFieldValue('municipality', value)}
                label="Comune sede consolare"
                params={{
                  italia: false,
                }}
                handleBlur={() => filterConsulateForm.setFieldTouched('municipality', true)}
                error={
                  filterConsulateForm.touched.municipality &&
                  Boolean(filterConsulateForm.errors.municipality)
                }
              />
            </Grid>
            <Grid item xs>
              <PmiButton
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filterConsulateForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersConsulate.displayName = 'Filters Consulate component';

export default FiltersConsulate;
